import { BillTypeEnum } from 'api';
import { SelectField, SelectFieldProps } from 'form';

export type BillTypeSelectFieldProps = Omit<SelectFieldProps, 'options'>;

const options: SelectFieldProps['options'] = Object.entries(BillTypeEnum).map(([key, value]) => ({
  label: key,
  value,
}));

export const BillTypeSelectField = ({ ...props }: BillTypeSelectFieldProps) => {
  return <SelectField {...props} options={options} />;
};
